import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function EditWorkOrderRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        const response = await axios.get(`${API}/work-orders`);
        const workOrder = response.data.find(wo => wo.id === id);
        if (workOrder) {
          navigate("/workorder/create-new", { state: { editData: workOrder }, replace: true });
        } else {
          navigate("/workorder", { replace: true });
        }
      } catch (err) {
        navigate("/workorder", { replace: true });
      }
    };
    fetchAndRedirect();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-400">Loading work order...</div>
      </div>
    );
  }
  return null;
}
